import Entity from './entity'
export default class User extends Entity<number>{
    password:string='';
    userName: string='';
    name: string='';
    surname: string='no';
    emailAddress: string='';
    isActive: boolean=true;
    roleNames: Array<string>=[];
    phoneNumber: string='';
    avatar: string = '';
    gradeNum: number = null;
    amount: number = 0;
    code:string=""
}